export default __webpack_public_path__ + "static/media/3.31269924.jpg";